import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5122824a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app max-w-lg mx-auto text-center mt-8" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-normal leading-normal mt-0 mb-2 text-pink-800" }, " Chargement du jeu ... ", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "text-red-500 mt-4"
}
const _hoisted_7 = { class: "font-bold" }

import { ref, reactive, onMounted } from 'vue';
import GameBoard from './components/GameBoard.vue';
import InputArea from './components/InputArea.vue';
import Notification from './components/Notification.vue';
import { Attempt, LetterStatus } from './types/game.types';
import { fetchWordList } from './services/WordlistService';

const MAX_TRIES = 7;
const wordLength = 6;


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {

const wordList = ref<string[]>([]);
const correctWord = ref('');
const attempts = ref<Attempt[]>([]);
const currentAttempt = ref(0);
const gameOver = ref(false);
const won = ref(false);
const loading = ref(true);

const notification = reactive({
  show: false,
  message: '',
  type: 'info' as 'success' | 'error' | 'info',
  duration: 3000,
});

const initializeGame = async () => {
  wordList.value = await fetchWordList();

  if (wordList.value.length === 0) {
    triggerNotification('Erreur lors du chargement de la liste de mots', 'error');
    return;
  }

  // Selection d'un mot aléatoire à trouver parmi la liste récupérée de l'API
  correctWord.value = wordList.value[Math.floor(Math.random() * wordList.value.length)];

// Crée un tableau de tentatives, où chaque tentative contient un identifiant unique (id) et un tableau de lettres initialisées avec des valeurs par défaut
attempts.value = Array.from({ length: MAX_TRIES }, (_, i) => ({
  id: i,
  letters: Array.from({ length: wordLength }, () => ({ value: '', status: 'unknown' as LetterStatus })) // Tableau de lettres initialisé avec des valeurs par défaut
}));


  currentAttempt.value = 0;
  gameOver.value = false;
  won.value = false;
  loading.value = false; 
};

const handleWordSubmission = (word: string) => {
  console.log('Word submitted:', word);

  if (!wordList.value.includes(word)) {
    triggerNotification('Mot non valide', 'error');
    return;
  }

  const attempt = attempts.value[currentAttempt.value];

  for (let i = 0; i < word.length; i++) {
    attempt.letters[i].value = word[i];
    attempt.letters[i].status = (word[i] === correctWord.value[i])
      ? 'correct'
      : (correctWord.value.includes(word[i]))
        ? 'present'
        : 'absent';
  }

  if (word === correctWord.value) {
    gameOver.value = true;
    won.value = true;
    triggerNotification('Félicitations, vous avez gagné!', 'success');
  } else if (currentAttempt.value >= MAX_TRIES - 1) {
    gameOver.value = true;
    triggerNotification('Jeu terminé, vous avez perdu', 'error');
  } else {
    currentAttempt.value++;
  }
};

const triggerNotification = (message: string, type: 'success' | 'error' | 'info') => {
  notification.show = true;
  notification.message = message;
  notification.type = type;
  setTimeout(() => {
    notification.show = false;
  }, notification.duration);
};

const clearNotification = () => {
  notification.show = false;
};

const restartGame = () => {
  initializeGame(); // Réinitialise l'état du jeu
};

__expose({ loading, gameOver, restartGame });

onMounted(initializeGame);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(GameBoard, {
            attempts: attempts.value,
            "game-over": gameOver.value,
            "correct-word": correctWord.value
          }, null, 8, ["attempts", "game-over", "correct-word"]),
          _createVNode(InputArea, {
            "is-disabled": gameOver.value,
            onSubmit: handleWordSubmission
          }, null, 8, ["is-disabled"]),
          (notification.show)
            ? (_openBlock(), _createBlock(Notification, {
                key: 0,
                message: notification.message,
                type: notification.type,
                duration: notification.duration,
                onDismiss: clearNotification
              }, null, 8, ["message", "type", "duration"]))
            : _createCommentVNode("", true),
          (gameOver.value && !won.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Le mot mystère est: "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(correctWord.value), 1)
              ]))
            : _createCommentVNode("", true),
          (gameOver.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "replay-button bg-blue-600 text-white rounded p-2 mt-4",
                onClick: restartGame
              }, " Rejouer "))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})